import { _deepEquals } from '@naturalcycles/js-lib'
import type { MonoTypeOperatorFunction } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators'

export function distinctUntilDeeplyChanged<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged<T>((a, b) => _deepEquals(a, b))
}
